/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Perk_CoachInputs */

const en_portal_perk_coach = /** @type {(inputs: Portal_Perk_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions with a coach`)
};

const pl_portal_perk_coach = /** @type {(inputs: Portal_Perk_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi z trenerem`)
};

/**
* | output |
* | --- |
* | "Sessions with a coach" |
*
* @param {Portal_Perk_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_perk_coach = /** @type {((inputs?: Portal_Perk_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Perk_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_perk_coach(inputs)
	return en_portal_perk_coach(inputs)
});